import { observer } from 'mobx-react-lite'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import { RateProDialog } from '@/features/jobs/details/ratings/components/RateProDialog'
import { type RateProDialogViewModel } from './RateProDialogViewModel'

export interface RateProDialogContainerProps {
  vm: RateProDialogViewModel
}

export const RateProDialogContainer = observer(function RateProDialogContainer({
  vm,
}: RateProDialogContainerProps) {
  const member = vm.proChampion?.member
  return (
    <RateProDialog
      showing={vm.modal.showing}
      proAvatar={
        member && {
          avatar: member.avatar,
          avatarFallback: member.avatarFallback,
          displayName: member.displayName,
        }
      }
      proGivenName={member?.givenName}
      ratingMethod={vm.ratingMethod}
      rating={vm.rating}
      thumbsRating={vm.thumbsRating}
      feedbackField={
        <TextAreaContainer
          rows={3}
          label="Add a written review"
          placeholder="Tell us more about your experience."
          help="This feedback is optional."
          model={vm}
          field="feedback"
          name="feedback"
          data-test="rate-pro-feedback"
        />
      }
      isRateProPending={vm.ratePro.pending}
      validRating={vm.validRating}
      onClose={vm.modal.close}
      onRatingChange={vm.setRating}
      onThumbsRatingChange={vm.setThumbsRating}
      onRatePro={vm.ratePro}
    />
  )
})
